import { ControlFacet } from '../models/controls/ControlFacet';
import { IItemCache } from '../models/IItemCacheObserver';

export type IItemSetSelectionMode = 'none' | 'single' | 'multiple';

/**
 * Control for the binding of the current selection to a Fabric Selection model.
 */
export const itemSetSelectionControl: ControlFacet<{
  itemsScopeItemKey: string;
}, {
    /**
     * The selection mode to apply.
     *
     * @type {IItemSetSelectionMode}
     */
    selectionMode: IItemSetSelectionMode;
    canSelectItem: (itemCache: IItemCache, props: { itemKey: string; }) => boolean;
  }> = new ControlFacet('currentSelectionControl');
